import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
  'generatingOrderNote': false,
  'oderNoteUrl': '',
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const invoicesQuery = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_INVOICES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_INVOICES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'page': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_INVOICES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'page': [],
    }),
    [ActionTypes.CLEAR_INVOICES_DATA]: (state, action) => ({
      ...state,
      'pageNumber': 0,
      'pageSize': 20,
      'list': '',
      'page': [],
    }),
    [ActionTypes.CHANGE_INVOICES_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'page': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_INVOICES_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'page': [...getPage(state.list, 0, action.payload)],
    }),
    [ActionTypes.GENERATE_ORDER_NOTE_REQUEST]: (state, action) => ({
      ...state,
      'generatingOrderNote': true,
    }),
    [ActionTypes.GENERATE_ORDER_NOTE_SUCCESS]: (state, action) => ({
      ...state,
      'generatingOrderNote': false,
      'oderNoteUrl': action.response.data,
    }),
    [ActionTypes.GENERATE_ORDER_NOTE_FAILED]: (state, action) => ({
      ...state,
      'generatingOrderNote': false,
      'oderNoteUrl': '',
    }),
    [ActionTypes.CLEAR_ODER_NOTE_URL]: (state, action) => ({
      ...state,
      'oderNoteUrl': '',
    }),
  })(state, action);
};
